import { render, staticRenderFns } from "./BoardMembersSection.vue?vue&type=template&id=25337ad9&scoped=true&"
import script from "./BoardMembersSection.vue?vue&type=script&lang=js&"
export * from "./BoardMembersSection.vue?vue&type=script&lang=js&"
import style0 from "./BoardMembersSection.vue?vue&type=style&index=0&id=25337ad9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25337ad9",
  null
  
)

export default component.exports